// import React from 'react'
// import { Link } from 'react-router-dom'

// const Footer = () => {
//     return (
//         <div>

//             <div className="tags-sec full-width">
//                 <ul>

//                     <li><Link href="#" title="">About</Link></li>
//                     <li><Link href="#" title="">Privacy Policy</Link></li>
//                     <li><Link href="#" title="">Cookies Policy</Link></li>
//                     <li><Link href="#" title="">Copyright Policy</Link></li>
//                 </ul>
//                 <div className="cp-sec">
//                     <img src="images/logo2.png" alt="" />
//                     <p><img src="images/cp.png" alt="" />Copyright 2023</p>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Footer

import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../../images/talentlogo.png';

const Footer = () => {
  return (
    <div className="tags-sec full-width text-center">

      {/* Links */}
      <ul className="d-flex justify-content-center align-items-center gap-3 list-unstyled mb-3">
        <li>
          <Link to="/privacy" className="text-decoration-none text-muted">
            Privacy Policy
          </Link>
        </li>
        <li>
          <Link to="/cookies" className="text-decoration-none text-muted">
            Cookies Policy
          </Link>
        </li>
        <li>
          <Link to="/copyright" className="text-decoration-none text-muted">
            Copyright Policy
          </Link>
        </li>
      </ul>

      {/* Bottom */}
      <div className="cp-sec d-flex flex-column align-items-center">
        <img src={logo} alt="logo" width="120" className="mb-2" />
        <p className="mb-0 text-muted">Copyright 2023</p>
      </div>

    </div>
  )
}

export default Footer